"use strict";

var _slicedToArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useUpdate = function useUpdate() {
  var _react_1$useState = react_1.useState(0),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      setState = _react_1$useState2[1];

  return function () {
    return setState(function (cnt) {
      return cnt + 1;
    });
  };
};

exports.default = useUpdate;